import angular from 'angular';

import PeriodMonthItemComponent from './period-month-item.cmpt';

export default angular
    .module('application.scene.authorized.scene.calendar.component.calendar-header.component.calendar-period.component.period-month-item', [])
    .component(PeriodMonthItemComponent.selector, PeriodMonthItemComponent);



// WEBPACK FOOTER //
// ./src/application/scene/authorized/scene/calendar/component/calendar-header/component/calendar-period/component/period-month-item/index.js